import webBiLogger from '@wix/web-bi-logger';
import { resolveAuthToken } from './utils/auth-utils';
import { bsiManager } from './bsi-manager';
import { getPageNumber } from './page-number';
import { getViewerSessionId } from './viewer-session-id';

export const biLogger = webBiLogger
  .factory()
  .withNonEssentialContext({
    _authToken: () => {
      const token = resolveAuthToken();

      return token;
    },
    bsi: () => {
      const bsi = bsiManager.getBsi(getPageNumber());

      return bsi;
    },
    vsi: getViewerSessionId,
  })
  .logger();
